import { ApexOptions } from 'apexcharts';
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useLazyGetMilestoneDashboardDataQuery } from 'src/services/SummaryDashboard';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useAppSelector } from 'src/store/hooks';
import { archLevel } from 'src/data/config';

const MilestoneWidget = () => {
  const { selectedApp } = useSelectedAppInfo();
  const studyId = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const appName = archLevel == 'site' ? process.env.REACT_APP_NAME_TEMP : process.env.REACT_APP_NAME;

  const [mileStoneMonth, setMilestoneMonth] = useState<any>([]);
  const [actualMileStone, setActualMileStone] = useState<any>([]);
  const [plannedMileStone, setplannedMileStone] = useState<any>([]);
  const [isWidgetDataLoading, setIsWidgetDataLoading] = useState(false);
  const [getMilestoneDashboardData] = useLazyGetMilestoneDashboardDataQuery();

  const getAllMilestoneDashboardData = async () => {
    setIsWidgetDataLoading(true);
    const milestoneDashboardResponse = await getMilestoneDashboardData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: appName,
      application_section: selectedApp
    });
    if (milestoneDashboardResponse?.isSuccess) {
      if (milestoneDashboardResponse?.data?.milestone_progress?.length) {
        const currentYearMileStones = milestoneDashboardResponse?.data.milestone_progress.filter((item: any) =>
          item.month_year.includes(new Date().getFullYear())
        );
        const tempMonth: any[] = [];
        const tempActual: any[] = [];
        const tempPlanned: any[] = [];
        currentYearMileStones?.map((obj: any) => {
          tempMonth.push(obj?.month_year.split('-')[0]);
          tempActual.push(Math.round(obj?.actual_minor_milestones));
          tempPlanned.push(Math.round(obj?.planned_minor_milestones));
        });
        setMilestoneMonth(tempMonth);
        setActualMileStone(tempActual);
        setplannedMileStone(tempPlanned);
      }
    } else if (milestoneDashboardResponse?.isError) {
      setMilestoneMonth([]);
      setActualMileStone([]);
      setplannedMileStone([]);
    }
    setIsWidgetDataLoading(false);
  };
  useEffect(() => {
    setMilestoneMonth([]);
    setActualMileStone([]);
    setplannedMileStone([]);
    getAllMilestoneDashboardData();
  }, [selectedSite]);

  const options: ApexOptions = {
    chart: {
      height: 350,
      type: 'bar',
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      }
    },
    dataLabels: {
      enabled: false
    },

    grid: {
      show: true,
      borderColor: '#F0F0F0',
      xaxis: {
        lines: {
          show: true
        }
      },
      yaxis: {
        lines: {
          show: true
        }
      }
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      markers: {
        height: 8,
        width: 8,
        fillColors: ['#243F81', '#4CAF50'],
        strokeWidth: 0
      },
      itemMargin: {
        horizontal: 10,
        vertical: 1
      },
      onItemClick: { toggleDataSeries: false },
      onItemHover: {
        highlightDataSeries: false
      }
    },
    tooltip: {
      enabled: true,
      x: {
        show: false
      },
      y: {
        formatter(val) {
          return val.toFixed(0);
        }
      }
    },

    stroke: {
      show: false,
      curve: 'smooth',
      lineCap: 'butt',
      colors: ['#243F81', '#4CAF50'],
      width: 2
    },
    xaxis: {
      categories: mileStoneMonth,
      labels: {
        style: {
          colors: mileStoneMonth.map(() => '#A3A3A3')
        }
      },
      tooltip: {
        enabled: false
      }
    },

    yaxis: {
      labels: {
        formatter(val) {
          return val.toFixed(0);
        },
        style: { colors: mileStoneMonth.map(() => '#A3A3A3') }
      },
      title: { text: 'Milestone Count' },
      forceNiceScale: true,
      floating: false
    },
    fill: {
      opacity: 1
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%'
      }
    }
  };
  const series = [
    {
      name: 'Planned',
      data: plannedMileStone,
      color: '#243F81'
    },
    {
      name: 'Actual',
      data: actualMileStone,
      color: '#4CAF50'
    }
  ];
  return (
    <>
      <Typography variant="h6" fontWeight={700} ml={3} style={{ marginLeft: '4px' }}>
        Milestone Progress {isWidgetDataLoading && <CircularProgress size="1.5rem" style={{ position: 'relative' }} />}
      </Typography>
      <Box sx={{ padding: '0 8px 0px 0px', marginTop: '-24px' }}>
        <Chart options={options} series={series} type="bar" />
      </Box>
    </>
  );
};

export default MilestoneWidget;
